module.exports = __webpack_public_path__ + "static/media/TeacherMen.bbaa96c3.svg";